<template>
  <div v-if="loaded">
    <FormComponent :metadata='metadata1' dbfield="start" v-model="groupvalue['start']"
      v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="false"
      v-on:updatex="updatex"/>
    <FormComponent :metadata='metadata2' dbfield="end" v-model="groupvalue['end']"
      v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="false"
      v-on:updatex="updatex"/>
  </div>
</template>

<script>
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentRange',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      groupvalue: {},
      metadata1: {},
      metadata2: {},
      loaded: false
    }
  },
  mounted () {
    for (var i in this.metadata) {
      if (i !== 'label') {
        this.metadata1[i] = this.metadata[i]
        this.metadata2[i] = this.metadata[i]
      }
    }
    this.metadata1.label = this.metadata.label + ' (desde)'
    this.metadata2.label = this.metadata.label + ' (hasta)'
    this.loaded = true
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
    }
  }
}
</script>
